import rights from '../../../../components/rights';
import ganttFilterHelper from '$$helpers/gantt_filter';

class Filter {
  constructor() {
    this.range = null;
    this.ganttInstance = null;
  }

  init(instance, config) {
    this.ganttInstance = instance;
    this.range = config.range;
  }

  _getFilterState() {
    const filterState = this.ganttInstance.ganttDataApi.getCurrentFilter()?.properties;

    const result = { ...filterState };
    const assigneeFilter = result.assignee || result.resources;

    if (assigneeFilter?.length) {
      result.assignee = [...assigneeFilter];
      result.assignee = result.assignee.map(resourceId => (resourceId === '-1' ? 'unassigned' : +resourceId || 'unassigned'));
    }

    return result;
  }

  isActive() {
    return this.ganttInstance.ganttDataApi.isFilterActive();
  }

  isFilteredByProjects() {
    const filterState = this._getFilterState();

    return !!filterState.gantt_id?.length;
  }

  isFilteredByUnassigned() {
    const filterState = this._getFilterState();

    return !!filterState.assignee?.includes('unassigned') || !filterState.assignee?.length;
  }

  filterProjects(projectIds) {
    const filterState = this._getFilterState();

    return filterState.gantt_id?.length ? filterState.gantt_id : projectIds;
  }

  filterResources(resources, scopedProjectIds) {
    let filtredResources = [];
    const filterState = this._getFilterState();
    const scopeSet = scopedProjectIds?.length ? new Set(scopedProjectIds.map(id => +id)) : null;

    // Only resources that participate in at least one in-scope project the user can access for workload
    filtredResources = resources.filter(resource => resource.resourceProjects?.some(project => {
      const pid = +project.projectId;
      const inScope = !scopeSet || scopeSet.has(pid);

      return inScope && rights.project.hasRight(project.projectId, 'workload');
    }));

    if (filterState.assignee?.length) {
      filtredResources = filtredResources.filter(resource => filterState.assignee.find(id => id === resource.id || String(resource.id).includes(id)));
    }

    return filtredResources;
  }

  filterTasks(tasks) {
    let filteredTasks = [];

    const options = this._getFilterState();

    delete options.assignee;
    delete options.gantt_id;

    const filterFunction = ganttFilterHelper.getFilter({
      options,
    }, null);

    filteredTasks = tasks.filter(filterFunction);

    return filteredTasks;
  }

  filterByRange() {
    return [];
  }
}

export default new Filter();
